// extracted by mini-css-extract-plugin
export default {"base":"vp_GHa2y","toggle":"vp_EGS3n","flag":"vp_UgXAy","menu":"vp_vyAOC","item":"vp_shJM6","label":"vp_MNUwi"};